import React from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  Redirect,
  // Link
} from "react-router-dom";
import './style.css';
// import './bootstrapmin.5.0.2.css';
import '../../resources/main.css';
import '../../resources/fontawesome/css/fontawsome-470.css';
import Routes from '../../util/routes';
import ChooseClient from '../clients/ChooseClient';
import CreateClient from '../clients/CreateClient';
import ChooseQuestionnaire from '../questionnaires/ChooseQuestionnaire';
import { insertQuestionnaires, insertUnites } from '../../mock/data';
import Questionnaire from '../questionnaires/Questionnaire';

function initDb() {
  insertQuestionnaires();
  insertUnites();
}

initDb();

function App() {
  return (
    <Router>
      <Switch>
        <Route path={Routes.CHOOSE_CLIENT}>
          <ChooseClient />
        </Route>
        <Route path={Routes.CREATE_CLIENT}>
          <CreateClient />
        </Route>
        <Route path={`${Routes.PROCESS_QUESTIONNAIRE}/:clientId/:questionnaire/:page`}>
          <Questionnaire />
        </Route>
        <Route path={`${Routes.CHOOSE_QUESTIONNAIRE}/success/:clientId`}>
          <ChooseQuestionnaire />
        </Route>
        <Route path={`${Routes.PROCESS_QUESTIONNAIRE}/:clientId/:questionnaire`}>
          <Redirect to={`${window.location.pathname}/0`} />
        </Route>
        <Route path={`${Routes.CHOOSE_QUESTIONNAIRE}/:clientId`}>
          <ChooseQuestionnaire />
        </Route>
        <Route>
          <div>
            <h1>Bienvenue sur parvisio itinérant (v6)</h1>
            <Link to={Routes.CHOOSE_CLIENT}>Commencer un questionnaire</Link>
          </div>
        </Route>
      </Switch>
    </Router>
  );
}

export default App;
